import React from 'react'
import { parseLocale } from '@jarvis.oddle/core/tools/localisation'
import OneMapApi from '@jarvis.oddle/core/api/map/onemap'
import GoogleMapService from './GoogleMapService'
import OneMapService from './OneMapService'
import { isEmpty } from 'src/utils/string'
import { useRouter } from 'next/router'

export const mapServices = {
  GOOGLE_MAP: 'GOOGLE_MAP',
  ONE_MAP: 'GOOGLE_MAP'
}

const MapService = ({
  mapService,
  children,
  ...props
}: {
  mapService?: string
  children?: (mapServiceProps) => JSX.Element;
}): JSX.Element => {
  const router = useRouter()
  const { locale = 'en_SG' } = router.query || {}
  const { country } = parseLocale(locale)
  const [isOneMapDown, setIsOneMapDown] = React.useState(false)
  const hasOneMapResponsed = React.useRef(false)

  const setMapServiceProvider = () => {
    switch (mapService) {
      case mapServices.GOOGLE_MAP:
        return GoogleMapService
      case mapServices.ONE_MAP:
        return OneMapService
      default:
        return null
    }
  }

  const autoSetMapServiceProvider = () =>
    country === 'SG' && !isOneMapDown ? OneMapService : GoogleMapService

  const MapServiceProvider = !isEmpty(mapService)
    ? setMapServiceProvider()
    : autoSetMapServiceProvider()

  React.useEffect(() => {
    if (MapServiceProvider === OneMapService) {
      // HOTFIX: auto switch to Google Maps if OneMap does not response within 2 secs to cater the case where OneMap is unstable
      setTimeout(() => {
        if (hasOneMapResponsed.current === false) {
          setIsOneMapDown(true)
        }
      }, 2 * 1000)
      OneMapApi()
        .getApiHealthStatus()
        .then((response) => {
          setIsOneMapDown(!response)
          hasOneMapResponsed.current = true
        })
    }
  }, [MapServiceProvider, isOneMapDown])

  return <MapServiceProvider {...props}>{children}</MapServiceProvider>
}

export default MapService
